<script lang="ts">
  // libs
  import { onMount } from "svelte";

  // components
  import InvoiceDetailCard from "@retailer/svelte/Payments/InvoiceDetailCard.svelte";
  import Payment from "@retailer/svelte/Payments/PaymentDetails/Payment.svelte";
  import InvoiceBannerSelector from "@retailer/svelte/Payments/Banners/selectors/InvoiceBannerSelector.svelte";

  // services
  import * as InvoiceService from "@retailer/services/invoice_service";
  import * as DwollaIdentityService from "@retailer/services/dwolla_identity_service";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { InvoiceEntity } from "@shared/services/event_tracking/entities";
  import * as SuspensionService from "@retailer/services/suspension_service";

  // stores
  import { InvoiceStore } from "@retailer/stores/InvoiceStore";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // props
  export let invoiceId: number;

  // data
  const { trackEvent } = EventTracking;

  // lifecycle
  onMount(async () => {
    (async () => {
      await InvoiceService.get(invoiceId);
      await SuspensionService.get();
      await DwollaIdentityService.get();
      if (invoicePresent) {
        trackEvent(
          "invoice_view",
          new InvoiceEntity({
            created_at: $InvoiceStore.invoice.created_at,
            due_date: $InvoiceStore.invoice.due_date,
            status: $InvoiceStore.invoice.invoice_status_type,
            distributor: $InvoiceStore.invoice.distributor.name,
            amount_due: parseFloat($InvoiceStore.invoice.amount_due),
            retailer_id: $InvoiceStore.invoice.retailer_id,
            provi_order_id: $InvoiceStore.invoice.order?.id,
            delivery_date: $InvoiceStore.invoice.order?.delivery_date,
            invoice_id: $InvoiceStore.invoice.id,
            in_provi_pay: true,
          }),
        );
      }
    })();
  });

  // reactives
  $: invoicePresent = $InvoiceStore.invoice !== undefined;
</script>

{#if invoicePresent}
  <div class="fizz-layout-invoice fizz-inset-square-16">
    {#if $LayoutStore.isMobile}
      <InvoiceBannerSelector />
      <div class="fizz-bordered" data-grid-area="pay-cta">
        <Payment invoice={$InvoiceStore.invoice} />
      </div>
    {/if}
    <div class="fizz-bordered" data-grid-area="table" style="align-self: start">
      <InvoiceDetailCard invoice={$InvoiceStore.invoice} />
    </div>
    {#if $LayoutStore.isDesktop}
      <div>
        <InvoiceBannerSelector />
        <div class="fizz-bordered" data-grid-area="pay-cta">
          <Payment invoice={$InvoiceStore.invoice} />
        </div>
      </div>
    {/if}
  </div>
{:else}
  <main data-grid-area="main">
    <div class="fizz-container fizz-grid-center">
      <div class="fizz-icon-spinner" style={"margin-top: 25vh"} />
    </div>
  </main>
{/if}
